import {
  RangeSlider as ChakraRangeSlider,
  RangeSliderProps,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  GridItem,
  SimpleGrid,
} from '@chakra-ui/react';
import { useCallback } from 'react';

export const RangeSlider = ({
  min,
  max,
  defaultValue,
  onChangeEnd,
  onChange,
  value,
  ...props
}: RangeSliderProps) => {
  const handleOnChangeEnd = useCallback(
    (valueOnChangeEnd: number[]) => {
      onChangeEnd?.(valueOnChangeEnd);
    },
    [onChangeEnd]
  );

  const handleOnChange = useCallback(
    (valueOnChange: number[]) => {
      onChange?.(valueOnChange);
    },
    [onChange]
  );

  return (
    <ChakraRangeSlider
      min={min}
      max={max}
      onChangeEnd={handleOnChangeEnd}
      onChange={handleOnChange}
      defaultValue={defaultValue}
      value={value}
      {...props}
    >
      <RangeSliderTrack bg='purple.300' outlineOffset={0}>
        <RangeSliderFilledTrack bg='primary.500' />
      </RangeSliderTrack>
      <RangeSliderThumb
        boxSize={5}
        index={0}
        outlineOffset={0}
        outlineColor='primary.500'
        outline='solid 1.5px'
        borderRadius='50%'
        zIndex={0}
      >
        <SimpleGrid color='primary.500' spacing={0.5} columns={2}>
          <GridItem h='11px' borderRight='1px' color='primary.500' />
          <GridItem
            h='9px'
            borderRight='1px'
            color='primary.500'
            alignSelf='center'
          />
        </SimpleGrid>
      </RangeSliderThumb>
      <RangeSliderThumb
        boxSize={5}
        index={1}
        outlineOffset={0}
        outlineColor='primary.500'
        outline='solid 1.5px'
        borderRadius='50%'
        zIndex={0}
      >
        <SimpleGrid color='primary.500' spacing={0.5} columns={2}>
          <GridItem
            h='9px'
            borderRight='1px'
            color='primary.500'
            alignSelf='center'
          />
          <GridItem h='11px' borderRight='1px' color='primary.500' />
        </SimpleGrid>
      </RangeSliderThumb>
    </ChakraRangeSlider>
  );
};
